'use client'

import { useState } from 'react'
import { InputsPanel } from './InputsPanel'
import { ResultsPanel } from './ResultsPanel'
import { ScheduleStickyBar } from '../../../chrome/ScheduleStickyBar'
import { useTrackingUrl } from '../../../hooks/use-tracking-url'
import { CTA, SCHEDULE_TRACKING_OPTIONS } from '../../../utils/ctas'
import { useCalculator } from '../_hooks/use-calculator'

export function RentVsBuyCalculator() {
  const { state, setters, results } = useCalculator()
  const [showFloatBar, setShowFloatBar] = useState(true)
  const trackedUrl = useTrackingUrl(CTA.SCHEDULE_PAGE, SCHEDULE_TRACKING_OPTIONS)

  return (
    <div className="bg-background">
      <div className="relative mx-auto flex max-w-screen-md flex-col gap-5 px-3.5 pb-12 tablet:-mt-5 tablet:px-6">
        <InputsPanel state={state} setters={setters} results={results} />
        <ResultsPanel state={state} results={results} />
        <div className="px-2 text-center">
          <p className="mx-auto max-w-155 text-subtitle leading-relaxed text-neutral-dark">
            Results are for illustrative purposes only and do not constitute financial advice. Calculations use
            simplified models and do not account for mortgage interest deductions, property tax deductions, opportunity
            cost nuances, or local market conditions. Interest is calculated monthly.
          </p>
        </div>
      </div>
      {showFloatBar && <ScheduleStickyBar href={trackedUrl} onDismiss={() => setShowFloatBar(false)} />}
    </div>
  )
}
